import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import {
  getBreathTrainingDashboardDataApi,
  updateBreathTrainingCommentApi,
  markBreathTrainingRowAsImportantApi
} from '../../services/breath-training';
import { BreathTrainingRow } from 'data/breath-training/types';

const BREATH_TRAINING_QUERY_KEY = ['breathTrainingDashboard'] as const;

export const useBreathTrainingQuery = () => {
  const queryClient = useQueryClient();

  const dashboardQuery = useQuery<BreathTrainingRow[]>({
    queryKey: BREATH_TRAINING_QUERY_KEY,
    queryFn: async () => {
      const response = await getBreathTrainingDashboardDataApi();
      return response?.breathTraining ?? [];
    }
  });

  const updateCommentMutation = useMutation({
    mutationFn: updateBreathTrainingCommentApi,
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<BreathTrainingRow[]>(BREATH_TRAINING_QUERY_KEY, (old) =>
        old?.map((row) => (row.id === variables.id ? { ...row, comment: variables.comment } : row))
      );
    }
  });

  const markImportantMutation = useMutation({
    mutationFn: markBreathTrainingRowAsImportantApi,
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<BreathTrainingRow[]>(BREATH_TRAINING_QUERY_KEY, (old) =>
        old?.map((row) =>
          row.id === variables.id ? { ...row, important: variables.important } : row
        )
      );
    }
  });

  return {
    dashboardData: dashboardQuery.data,
    isLoading: dashboardQuery.isLoading,
    error: dashboardQuery.error,

    updateCommentAsync: updateCommentMutation.mutateAsync,
    markImportant: markImportantMutation.mutate,

    isUpdatingComment: updateCommentMutation.isPending,
    isMarkingImportant: markImportantMutation.isPending
  };
};
